import { Box, Heading, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { ArrowContainer, Popover } from 'react-tiny-popover'

const WarningPopover = ({
  message,
  split = false,
  title = 'Data Sources and Limitations',
}: {
  message?: string
  split?: boolean
  title?: string
}) => {
  const [isOpen, setIsPopoverOpen] = useState(false)
  if (!message) return null
  return (
    <Popover
      isOpen={isOpen}
      positions={['right', 'left', 'bottom', 'top']}
      onClickOutside={() => setIsPopoverOpen(false)}
      content={({ position, childRect, popoverRect }) => (
        <ArrowContainer
          position={position}
          childRect={childRect}
          popoverRect={popoverRect}
          arrowColor='lightgrey'
          arrowSize={10}
          arrowStyle={{
            opacity: 0.7,
          }}
        >
          <Box
            bgColor='white'
            maxW={'500px'}
            marginTop='24px'
            borderRadius={15}
            p='24px'
            fontSize={'sm'}
            boxShadow='lg'
            border={'1px solid'}
            borderColor='gray.200'
          >
            <Heading fontSize={'lg'} mb={2}>
              {title}
            </Heading>
            {!split
              ? message
              : message
                  .split('\n')
                  .map((line, index) => <Text key={index}>{line}</Text>)}
          </Box>
        </ArrowContainer>
      )}
    >
      <Box
        onClick={() => setIsPopoverOpen((x) => !x)}
        width='fit-content'
        cursor='pointer'
        ml='1rem'
      >
        <Text
          variant='body'
          textDecor={'underline'}
          color='gray1'
          width='fit-content'
          whiteSpace={'break-spaces'}
          textAlign={'left'}
        >
          {title}
        </Text>
      </Box>
    </Popover>
  )
}

export default WarningPopover
